import { render, staticRenderFns } from "./MomentsCardGrid.vue?vue&type=template&id=88cfe8f4&scoped=true&"
import script from "./MomentsCardGrid.vue?vue&type=script&lang=js&"
export * from "./MomentsCardGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cfe8f4",
  null
  
)

export default component.exports